import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import T from 'utils/T';

export default function usePdfDisabled() {
  const pdf_targets = Recoil.useRecoilValue(AppStore.assets.pdf_targets);

  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);

  const glocose_data = Recoil.useRecoilValue(AppStore.assets.data('ReportBloodGlocose'));
  const diet_data = Recoil.useRecoilValue(AppStore.assets.data('ReportDiet'));
  const calories_data = Recoil.useRecoilValue(AppStore.assets.data('ReportExerciseCalories'));
  const steps_data = Recoil.useRecoilValue(AppStore.assets.data('ReportExerciseSteps'));
  const insulin_data = Recoil.useRecoilValue(AppStore.assets.data('ReportInsulin'));

  const glocose_high_list = Recoil.useRecoilValue(AppStore.assets.data('GlocoseHighList'));
  const glocose_low_list = Recoil.useRecoilValue(AppStore.assets.data('GlocoseLowList'));

  const glocose_profile_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocoseProfileChart'));
  const glocose_tir_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocoseTIRChart'));
  const glocose_distrubution_bar_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocoseDistributionBarChart'));
  const glocose_distrubution_scatter_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocoseDistributionScatterChart'));
  const glocose_pattern_weekday_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocosePatternWeekdayChart'));
  const glocose_pattern_weekend_chart = Recoil.useRecoilValue(AppStore.assets.data('GlocosePatternWeekendChart'));

  const diet_distrubution_doughnut_chart = Recoil.useRecoilValue(AppStore.assets.data('DietDistributionDoughnutChart'));
  const diet_distrubution_scatter_chart = Recoil.useRecoilValue(AppStore.assets.data('DietDistributionScatterChart'));
  const diet_meal_analysis_list = Recoil.useRecoilValue(AppStore.assets.data('DietMealAnalysisList'));
  const diet_food_analysis_list = Recoil.useRecoilValue(AppStore.assets.data('DietFoodAnalysisList'));
  const diet_statistics_chart = Recoil.useRecoilValue(AppStore.assets.data('DietStatisticsChart'));
  const diet_daily_statistics = Recoil.useRecoilValue(AppStore.assets.data('DietDailyStatistics'));

  const step_analysis_day_chart = Recoil.useRecoilValue(AppStore.assets.data('StepAnalysisDayChart'));
  const step_analysis_week_chart = Recoil.useRecoilValue(AppStore.assets.data('StepAnalysisWeekChart'));
  const step_statistics_chart = Recoil.useRecoilValue(AppStore.assets.data('StepStatisticsChart'));

  const calory_analysis_day_chart = Recoil.useRecoilValue(AppStore.assets.data('CaloryAnalysisDayChart'));
  const calory_analysis_week_chart = Recoil.useRecoilValue(AppStore.assets.data('CaloryAnalysisWeekChart'));
  const calory_statistics_chart = Recoil.useRecoilValue(AppStore.assets.data('CaloryStatisticsChart'));

  const exercise_daily_statistics_list = Recoil.useRecoilValue(AppStore.assets.data('ExerciseDailyStatisticsList'));

  const insulin_distrubution_doughnut_chart = Recoil.useRecoilValue(AppStore.assets.data('InsulinDistributionDoughnutChart'));
  const insulin_distrubution_scatter_chart = Recoil.useRecoilValue(AppStore.assets.data('InsulinDistributionScatterChart'));
  const insulin_bolus_analysis_list = Recoil.useRecoilValue(AppStore.assets.data('InsulinBolusAnalysisList'));
  const insulin_statistics_chart = Recoil.useRecoilValue(AppStore.assets.data('InsulinStatisticsChart'));
  const insulin_pattern_time_list = Recoil.useRecoilValue(AppStore.assets.data('InsulinPatternTimeList'));
  const insulin_statistics_day_chart = Recoil.useRecoilValue(AppStore.assets.data('InsulinStatisticsDayChart'));
  const insulin_stat_list = Recoil.useRecoilValue(AppStore.assets.data('InsulinStatList'));

  const disabled = React.useMemo(() => {
    if (!patient_no) return T('환자 정보');
    if (!period_start) return T('조회 시작 시간');
    if (!period_end) return T('조회 끝 시간');

    if (pdf_targets.B) {
      if (glocose_data.uninitialized) return T('혈당 정보');
      if (glocose_high_list.uninitialized) return T('고혈당 발생');
      if (glocose_low_list.uninitialized) return T('저혈당 발생');
      if (glocose_profile_chart.uninitialized) return T('혈당 개요 (AGP)');
      if (glocose_tir_chart.uninitialized) return T('혈당 개요 (TIR)');
      if (glocose_distrubution_bar_chart.uninitialized) return T('이상혈당 분포 (막대)');
      if (glocose_distrubution_scatter_chart.uninitialized) return T('이상혈당 분포 (산점도)');
      if (glocose_pattern_weekday_chart.uninitialized) return T('주중 혈당패턴');
      if (glocose_pattern_weekend_chart.uninitialized) return T('주말 혈당패턴');
    }

    if (pdf_targets.D) {
      if (diet_data.uninitialized) return T('식사 정보');
      if (diet_distrubution_doughnut_chart.uninitialized) return T('식사 분포 (도넛)');
      if (diet_distrubution_scatter_chart.uninitialized) return T('식사 분포 (산점도)');
      if (diet_meal_analysis_list.uninitialized) return T('식사별 분석');
      if (diet_food_analysis_list.uninitialized) return T('대표음식별 분석');
      if (diet_statistics_chart.uninitialized) return T('식사 일별 통계 (차트)');
      if (diet_daily_statistics.uninitialized) return T('식사 일별 통계 (표)')
    }

    if (pdf_targets.E) {
      if (steps_data.uninitialized) return T('걸음수 정보');
      if (step_analysis_day_chart.uninitialized) return T('걸음수 활동분석 (day)');
      if (step_analysis_week_chart.uninitialized) return T('걸음수 활동분석 (week)');
      if (step_statistics_chart.uninitialized) return T('걸음수 일별 통계');

      if (calories_data.uninitialized) return T('칼로리 정보');
      if (calory_analysis_day_chart.uninitialized) return T('칼로리 활동분석 (day)');
      if (calory_analysis_week_chart.uninitialized) return T('칼로리 활동분석 (week)');
      if (calory_statistics_chart.uninitialized) return T('칼로리 일별 통계');

      if (exercise_daily_statistics_list.uninitialized) return T('활동 일별 통계');
    }

    if (pdf_targets.I) {
      if (insulin_data.uninitialized) return T('인슐린 정보');
      if (insulin_distrubution_doughnut_chart.uninitialized) return T('인슐린 분포 (도넛)');
      if (insulin_distrubution_scatter_chart.uninitialized) return T('인슐린 분포 (산점도)');
      if (insulin_bolus_analysis_list.uninitialized) return T('인슐린 볼루스 분석');
      if (insulin_statistics_chart.uninitialized) return T('인슐린 통계 (차트)');
      if (insulin_pattern_time_list.uninitialized) return T('인슐린 통계 (표)');
      if (insulin_statistics_day_chart.uninitialized) return T('인슐린 일별 통계 (차트)');
      if(insulin_stat_list.uninitialized) return T('인슐린 일별 통계 (표)')
    }

    return false;
  }, [calories_data.uninitialized, calory_analysis_day_chart.uninitialized, calory_analysis_week_chart.uninitialized, calory_statistics_chart.uninitialized, diet_daily_statistics.uninitialized, diet_data.uninitialized, diet_distrubution_doughnut_chart.uninitialized, diet_distrubution_scatter_chart.uninitialized, diet_food_analysis_list.uninitialized, diet_meal_analysis_list.uninitialized, diet_statistics_chart.uninitialized, exercise_daily_statistics_list.uninitialized, glocose_data.uninitialized, glocose_distrubution_bar_chart.uninitialized, glocose_distrubution_scatter_chart.uninitialized, glocose_high_list.uninitialized, glocose_low_list.uninitialized, glocose_pattern_weekday_chart.uninitialized, glocose_pattern_weekend_chart.uninitialized, glocose_profile_chart.uninitialized, glocose_tir_chart.uninitialized, insulin_bolus_analysis_list.uninitialized, insulin_data.uninitialized, insulin_distrubution_doughnut_chart.uninitialized, insulin_distrubution_scatter_chart.uninitialized, insulin_pattern_time_list.uninitialized, insulin_stat_list.uninitialized, insulin_statistics_chart.uninitialized, insulin_statistics_day_chart.uninitialized, patient_no, pdf_targets.B, pdf_targets.D, pdf_targets.E, pdf_targets.I, period_end, period_start, step_analysis_day_chart.uninitialized, step_analysis_week_chart.uninitialized, step_statistics_chart.uninitialized, steps_data.uninitialized]);

  return disabled;
}
